import gql from 'graphql-tag';

import { PHOTO_FRAGMENT } from './photo';

export const USER_FRAGMENT = gql`
  ${PHOTO_FRAGMENT}
  fragment UserFragment on User {
    id
    firstName
    lastName
    email
    avatar {
      ...PhotoFragment
    }
  }
`;
